const shoppingCartDefaultState = {
  products: [],
}

export default (state = shoppingCartDefaultState, action) => {
  switch (action.type) {
    case "ADD_TO_CART":
      return { ...state, products: [...state.products, action.product] }
    case "REMOVE_FROM_CART":
      const cartWithProductRemoved = state.products.filter(
        product => product.id !== action.id
      )
      return { ...state, products: [...cartWithProductRemoved] }
    case "SET_QUANTITY":
      const cartWithProductUpdated = state.products.map(product => {
        return product.id === action.id
          ? { ...product, ...action.quantity }
          : product
      })
      return { ...state, products: [...cartWithProductUpdated] }

      case "CLEAR_CART":
        return { ...state, products: [] }

    default:
      return state
  }
}